import React from "react";
import { Modal } from "react-bootstrap";

/**
 * Race 20 rules (video (i) icon) — same markup as VideoBox's built-in rules panel/modal
 * (reference CasinoRules component). Used while the shared rules map has no "race20" entry.
 */
export default function Race20Rules({ html, show, onClose, showModal, onCloseModal }) {
  return (
    <>
      {show && (
        <div
          id="casino-vieo-rules"
          aria-modal="true"
          className="casino-vieo-rules show d-none-small show-rules"
          style={{ display: "block" }}
        >
          <div className="rules-header">
            <div>Rules</div> <i className="fas fa-times" onClick={onClose} />
          </div>{" "}
          <div className="rules-body" dangerouslySetInnerHTML={{ __html: html }} />
        </div>
      )}
      <Modal
        show={showModal}
        onHide={onCloseModal}
        className="casino-rules teenpatti2-rule-modal"
        dialogClassName="modal-md"
        id="rules-modal"
      >
        <header className="modal-header">
          <h5 className="modal-title">Rules</h5>{" "}
          <button type="button" aria-label="Close" className="close" onClick={onCloseModal}>
            ×
          </button>
        </header>
        <Modal.Body>
          <div className="casino-vieo-rules show-rules show">
            <div className="rules-body" dangerouslySetInnerHTML={{ __html: html }} />
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
